import { useEffect } from 'react'

/**
 * Call `callback` whenever the Escape key is pressed while `enabled` is true.
 * Used by modals/dialogs to close on Esc — the keyboard equivalent of clicking
 * the backdrop, which screen-reader users rely on.
 */
export default function useEscapeKey(callback, enabled = true) {
  useEffect(() => {
    if (!enabled) return
    const handler = (e) => {
      if (e.key === 'Escape') callback()
    }
    document.addEventListener('keydown', handler)
    return () => document.removeEventListener('keydown', handler)
  }, [callback, enabled])
}
